import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=1915bafa&scoped=true"
import script from "./Integration.vue?vue&type=script&lang=ts"
export * from "./Integration.vue?vue&type=script&lang=ts"
import style0 from "./Integration.vue?vue&type=style&index=0&id=1915bafa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1915bafa",
  null
  
)

export default component.exports